export default __webpack_public_path__ + "static/media/xp-spot.c95c41d3.svg";